import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _AbBasicHealthInfoFactory;
/* eslint-disable */
/**
 * Health
 * Ab Initio Health Services
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/health.yaml
// Template file: models.mustache (typescript-fetch)

// @ts-ignore noUnusedLocals
import { AbHealthBaseObjFactory } from "./AbHealthBaseObj";

/**
 * Health status of the application. Does not include health status of components.
 * @export
 * @interface AbBasicHealthInfo
 */

export class AbBasicHealthInfoFactory {}
_AbBasicHealthInfoFactory = AbBasicHealthInfoFactory;
_defineProperty(AbBasicHealthInfoFactory, "FromJSON", function (json) {
  return _AbBasicHealthInfoFactory.FromJSONTyped(json, false);
});
_defineProperty(AbBasicHealthInfoFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'appStatus': AbHealthBaseObjFactory.FromJSON(json['appStatus']),
    'appBuildId': json['appBuildId'],
    'appName': json['appName'],
    'appVersion': json['appVersion'],
    'appAvailable': json['appAvailable'],
    'appAvailableMessage': json['appAvailableMessage']
  };
});
_defineProperty(AbBasicHealthInfoFactory, "ToJSON", function (value) {
  return _AbBasicHealthInfoFactory.ToJSONTyped(false, value);
});
_defineProperty(AbBasicHealthInfoFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'appStatus': AbHealthBaseObjFactory.ToJSON(value.appStatus),
    'appBuildId': value.appBuildId,
    'appName': value.appName,
    'appVersion': value.appVersion,
    'appAvailable': value.appAvailable,
    'appAvailableMessage': value.appAvailableMessage
  };
});
//# sourceMappingURL=AbBasicHealthInfo.js.map
